import { Suspense, lazy } from "react";
import { Navigate, Route, Routes, useLocation, Location } from "react-router-dom";
import "./App.css";
import GAListener from "./GAListener";
import LoadingSpinner from "components/LoadingSpinner";

const Crest = lazy(() => import("pages/Crest"));
const Colours = lazy(() => import("pages/Colours"));
const TypographyPage = lazy(() => import("pages/Typography"));
const Graphics = lazy(() => import("pages/Graphics"));
const ArtDirection = lazy(() => import("pages/ArtDirection"));
const ToneOfVoicePage = lazy(() => import("pages/ToneOfVoice"));
const BrandInAction = lazy(() => import("pages/BrandInAction"));

const Navigation = () => {
  const location: Location = useLocation();

  return (
    <GAListener location = {location}>
      <Routes>    
        <Route
          path="/"
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <Navigate to="/brand/crest" />
            </Suspense>
          }
        />
        <Route path="brand">
          <Route index element={<Navigate to="/brand/crest" />} />
          <Route
            path="crest"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <Crest />
              </Suspense>
            }
          />
          <Route
            path="colours"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <Colours />{" "}
              </Suspense>
            }
          />
          <Route
            path="typography"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <TypographyPage />
              </Suspense>
            }
          />
          <Route
            path="graphics"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <Graphics />
              </Suspense>
            }
          />
          <Route
            path="art-direction"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <ArtDirection />
              </Suspense>
            }
          />
          <Route
            path="tone-of-voice"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <ToneOfVoicePage />
              </Suspense>
            }
          />
          <Route
            path="brand-in-action"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <BrandInAction />
              </Suspense>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/brand/crest" />} />
      </Routes>
    </GAListener>    
  );
};

export default Navigation;